import { App as CapacitorApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import * as Sentry from '@sentry/capacitor'
import { browserTracingIntegration, init } from '@sentry/vue'
import type { App } from 'vue'

import { PLATFORMS } from '@/constants/constants'

import {
  ANDROID_SENTRY_DSN,
  ENV,
  IOS_SENTRY_DSN,
  RELEASE_ID,
  SENTRY_TRACE_SAMPLE_RATE,
  WEB_SENTRY_DSN,
} from './settings'

export async function initSentry(app: App) {
  const dsnMap = {
    [PLATFORMS.IOS]: IOS_SENTRY_DSN,
    [PLATFORMS.ANDROID]: ANDROID_SENTRY_DSN,
    [PLATFORMS.WEB]: WEB_SENTRY_DSN,
  }

  const platform = Capacitor.getPlatform()
  const isWeb = platform === PLATFORMS.WEB

  const { build } = isWeb ? { build: 'web' } : await CapacitorApp.getInfo()

  if (dsnMap[platform]) {
    Sentry.init(
      {
        app,
        dsn: dsnMap[platform],
        dist: build,
        release: isWeb ? RELEASE_ID : `clienia-${platform}@${build}`,
        environment: ENV,
        integrations: [browserTracingIntegration()],
        tracesSampleRate: SENTRY_TRACE_SAMPLE_RATE,
        tracePropagationTargets: ['localhost', /^\//],
      },
      init
    )
  }
}
